import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ShopHeader } from "@/components/ShopHeader";
import { ShopFooter } from "@/components/ShopFooter";
import { StoreNav } from "@/components/StoreNav";
import { useLang } from "@/context/LanguageContext";
import { CaretRight } from "@phosphor-icons/react";

const VAN = "/legacy/promo/servitech-vans.jpg";
const BRANDS = [
  "/legacy/brands/3M-logo-079FB52BC8-seeklogo.com_-1.png",
  "/legacy/brands/Cascades_Inc_Logo.svg_-1.png",
  "/legacy/brands/clorox-Logo.png",
  "/legacy/brands/Product-GOJO-Brand.png",
  "/legacy/brands/Purell-logo-1.png",
  "/legacy/brands/Rubbermaid.svg_.png",
  "/legacy/brands/san-jamar.png",
  "/legacy/brands/Tork-Logo-700x394.png",
  "/legacy/brands/vileda.png",
  "/legacy/brands/lysol-Logo.png",
  "/legacy/brands/avmor.png",
  "/legacy/brands/continetal.png",
];

export default function AboutPage() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/shop/brands`).then((r) => setBrands(r.data || [])).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <ShopHeader />
      <div className="mx-auto max-w-[1280px] px-4 py-4"><StoreNav active="about" /></div>

      <div className="mx-auto max-w-[1280px] px-4 pb-8">
        <div className="mb-8 flex items-center gap-1 text-sm text-muted-foreground">
          <button onClick={() => navigate("/")} className="hover:text-primary">{t.home}</button>
          <CaretRight size={12} weight="bold" />
          <span className="text-foreground">{t.aboutCompany}</span>
        </div>

        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2">
          <div>
            <h1 className="mb-4 font-display text-4xl font-black tracking-tight text-[#2e3a47]" data-testid="about-title">{t.aboutTitle}</h1>
            <p className="text-[15px] leading-relaxed text-foreground/80">{t.aboutIntro}</p>
            <h2 className="mb-3 mt-8 font-display text-3xl font-black tracking-tight text-[#2e3a47]">{t.aboutPartnersTitle}</h2>
            <p className="text-[15px] leading-relaxed text-foreground/80">{t.aboutPartnersText}</p>
          </div>
          <div className="flex items-center justify-center">
            <img src={VAN} alt="Servitech Xpert" className="w-full max-w-[560px] object-contain" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          </div>
        </div>

        <div className="mt-14">
          <h2 className="mb-6 font-display text-3xl font-black tracking-tight text-[#2e3a47]">{t.aboutBrandsTitle}</h2>
          <div className="grid grid-cols-3 items-center gap-6 sm:grid-cols-4 md:grid-cols-6">
            {(brands.length ? brands.map((b) => ({ key: b.id, src: b.logo, alt: b.name })) : BRANDS.map((u) => ({ key: u, src: u, alt: "" }))).map((b) => (
              <div key={b.key} className="flex h-16 items-center justify-center rounded border border-border bg-white p-2">
                <img src={b.src} alt={b.alt} title={b.alt} className="max-h-full max-w-full object-contain grayscale transition hover:grayscale-0" onError={(e) => { e.currentTarget.style.display = "none"; }} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <ShopFooter />
    </div>
  );
}
